var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],class:['tab-pane fade',{'active show': _vm.active}],attrs:{"role":"tabpanel","id":_vm.tabId,"aria-hidden":!_vm.active,"aria-labelledby":`step-${_vm.tabId}`}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }